<section *ngIf="!!offer" class="w-100 h-100" [ngClass]="{ 'offer-preview-card': showValueProps, 'offer-card': !showValueProps }">
  <div class="offer-header-container d-flex">
    <header class="offer-header-content mb-lg-0">
      <h2 class="offer-heading">{{ offer.heading | uppercase }}</h2>
      <h3 class="plan-type" *ngIf="!isMonthly">{{ offer.title }}</h3>
    </header>
    <div class="savings-badge d-inline-flex justify-content-center align-items-center" *ngIf="showSavings && !!offer.caption?.text" [ngClass]="{ 'd-lg-none': !showValueProps }">
        <span class=savings-label>{{ savingsLabel }}</span><span class="savings-label savings-amount">{{ savingsAmount }}</span>
    </div>
  </div>
  <div class="pricing-container d-flex flex-column align-items-start">
    <div class="pricing-details d-flex align-items-baseline">
      <span class="price-amount">{{ offer.priceLabel }}</span>
      <span class="price-period">{{ pricePeriod }}</span>
    </div>
    <p class="billing-info">{{ billingInfo }}</p>
  </div>
  <button class="signup-button btn btn-lg btn-primary" [ngClass]="{ 'btn-dark': isMonthly }" (click)="handleClick(offer)">{{ buttonText }}</button>

  <!-- Value Props -->
  <div class="d-none d-lg-block value-props-container" *ngIf="showValueProps">
    <flo-value-prop
      *ngFor="let bullet of bulletPoints; trackBy: trackById"
      [proposition]="bullet.text"
      [label]="'single-click-plans'" 
      svgWidth="18"
    ></flo-value-prop>
  </div>

</section>

